import { Box } from "@mui/material";
import styles from "../ContractSearch.styles";
import { ArrowRightGlyph } from "./ContractSearchIcons";

interface PromptChipProps {
  text: string;
  onSelect: (text: string) => void;
  disabled?: boolean;
  /** The follow-up variant leads with a small arrow, as in the design. */
  arrow?: boolean;
}

/**
 * A suggested question the user can send with one click. A real `<button>`
 * (the mock used a `div`) so it is in the tab order and works with Enter/Space.
 */
const PromptChip = ({
  text,
  onSelect,
  disabled = false,
  arrow = false,
}: PromptChipProps) => (
  <Box
    component="button"
    type="button"
    onClick={() => onSelect(text)}
    disabled={disabled}
    sx={styles.chip}
  >
    {arrow && <ArrowRightGlyph sx={styles.chipArrow} />}
    {text}
  </Box>
);

export default PromptChip;
